import { render, staticRenderFns } from "./RequestGateEntryLogSynchronizationButton.vue?vue&type=template&id=161ee60d&"
import script from "./RequestGateEntryLogSynchronizationButton.vue?vue&type=script&lang=js&"
export * from "./RequestGateEntryLogSynchronizationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports